import { useQuery } from '@tanstack/react-query'
import { getActionLogsList } from '../api/actionLogs'

// Action Logs
export const useGetActionLogsList = (queryParams = '') => {
    return useQuery({
        queryKey: ['actions_logs', queryParams],
        queryFn: () => getActionLogsList(queryParams),
        enabled: !!queryParams
    });
};